import { IdResponseDto } from '@/shared/domain/entities/common.entity'

import { IEmailToSendRepository } from './emails-to-send.repository.interface'
import { CreateCustomEmailToSendBody } from './emails-to-send.schema'
import { EmailToSendResponse } from './emails-to-send.types'

export class EmailsToSendService {
  constructor(private emailsToSendRepository: IEmailToSendRepository) {}

  async get(id: string): Promise<EmailToSendResponse> {
    return this.emailsToSendRepository.get(id)
  }

  async createCustom(body: CreateCustomEmailToSendBody): Promise<IdResponseDto> {
    return this.emailsToSendRepository.createCustom(body)
  }
}
